export enum ViewerURLParam {
  CAROUSEL_INDEX = 'c', // custom index of the carousel start item
  HEADING = 'heading',
  PANO = 'pano',
  PITCH = 'pitch',
  THEME = 'theme',
  ZOOM = 'zoom',
}
